const klaviyoBisAppEl = document.getElementById('klaviyoBisApp')
const klaviyoBisApp = Vue.createApp({
    components: {
        'notify': NotifyMeModal,
    },
    emits: ['openNotifyModal'],
    data() {
        return {
            variant: {},
            showNotify: false,
            notifyLoading: false,
            notifySuccess: false,
            notifyItem: null
        }
    },
    created() {
        window.addEventListener('ehUpdateKlaviyoBtn', (e) => {
            this.variant = e.detail.variant;
        })
    },
    computed: {
        visible() {
            return !this.isEmpty(this.variant) && this.variant.hasOwnProperty('available') && this.variant.available === false;
        }
    },
    methods: {
        openNotifyModal(item) {
            document.body.classList.add('overflow-hidden');
            this.showNotify = true;
            this.notifyItem = item;
        },
        submitNotify(email,variantId) {
            if(!email || !variantId) {
                return false;
            }
            this.notifyLoading = true;
            backInStockSubscription(email,variantId)
                .then((response) => {
                    this.notifySuccess = true;
                    this.notifyLoading = false;
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.notifyLoading = false;
                });
        },
    },
    template: `
    <button v-if="visible" type="button" class="button button--full-width button--primary button--notify" @click.stop="openNotifyModal">
        <span>Notify Me When Available</span>
    </button>
    <teleport to="#klaviyoBisAppModal"><notify :show="showNotify" :loading="notifyLoading" :submitted="notifySuccess" :item="variant.id" @submit-notify="submitNotify" @close="showNotify = false; notifySuccess = false;"></notify></teleport>
    `
}, { ...klaviyoBisAppEl.dataset })
klaviyoBisApp.use(ehPlugin);
klaviyoBisApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('api')
klaviyoBisApp.config.unwrapInjectedRef = true
klaviyoBisApp.mount('#klaviyoBisApp')
